export { default as ClampedText } from './ClampedText';
